import { SectionHeaderProps } from '../constants/interface/interface';

const SectionHeader = ({ title }: SectionHeaderProps) => {
  return (
    <>
      <div className="section-header-underline" data-aos="fade-in">
        <h2>{title}</h2>
      </div>
    </>
  );
};

export default SectionHeader;
